/**
 * WhatsApp template rendering (#1471)
 *
 * Mirrors staff-api's `renderTemplateBody` so the composer can preview exactly
 * what the customer will receive before the send happens.
 */

const PLACEHOLDER_PATTERN = /\{\{\s*(\d+)\s*\}\}/g;

/**
 * Substitute `{{n}}` placeholders positionally. An unfilled placeholder stays
 * visible rather than collapsing to an empty string, so a half-filled template
 * looks unfinished instead of looking fine.
 */
export function renderTemplateBody(body: string, parameters: readonly string[]): string {
  return body.replace(PLACEHOLDER_PATTERN, (match, rawIndex: string) => {
    const value = parameters[Number(rawIndex) - 1];
    return value && value.length > 0 ? value : match;
  });
}
